import style from "./style.module.sass";
import React from "react";
import {useTheme} from "@material-ui/core/styles";
import {useTranslation} from "react-i18next";
import config from "../../../../config";
import {useSelector} from "react-redux";

export default function Tonality() {
    const {theme: {bgColors, colors}} = useTheme();
    const {t} = useTranslation();
    const resultData = useSelector(state => state.analyseData.result.resultData);
    const themeState = useSelector(state => state.userData.theme || localStorage.getItem('theme') || config.THEMES_MODES.LIGHT)
    
    const isContrast = themeState !== config.THEMES_MODES.LIGHT

    return <div className={`${style.secondPart}`} title={t('accessibility_analysis_tonality')} tabIndex={config.tabIndexes.tonalityWrapper} style={{backgroundColor: bgColors.bgPrimary0}}>
        <p style={{color: isContrast ? colors.colorContrast : colors.colorPrimary500}} className={`${style.title}`}>{t("Tonality")}</p>
        <div className={style.table}>
            {
                Object.entries(config.tonalityParameters).map(([key, val]) => {
                    if (resultData[key] !== undefined) {
                        const width = (resultData[key] - val.scaleFrom[0]) / ((val.scaleTo[0] - val.scaleFrom[0]) / 100);

                        return (
                            <span key={`span-${key}`} className={`${style.row}`}>
                                <p style={{color: isContrast ? colors.colorContrast : colors.colorPrimary500}}
                                   className={`m-0 ${style.row_title}`}>{t(val.nameOnTop)}</p>
                                <div style={{backgroundColor: bgColors.bgPrimary200}} className={style.bg} role="img"
                                aria-label= {`${t(val.nameOnTop)} ${t('accessibility_analysis_tonality{{width}}', { width: parseFloat(width).toFixed(1)})}`}>
                                    <div style={{width: `${width}%`, backgroundColor: isContrast ? bgColors.bgCockpitBar : bgColors.bgBar}} className={style.ranger}/>
                                </div>
                            </span>
                        );
                    }
                    return null;
                })
            }
        </div>
    </div>;
}